(app => {

    app.provider("medicareAccountApi",
        [
            function() {
                this.$get = (crmApiGateway) => {
                    const service = {
                        getMedicareAccount: (medicareAccountId) => {
                            return crmApiGateway.get(`/MedicareAccounts/${medicareAccountId}`);
                        },
                        getMedicareAccounts: () => {
                            return crmApiGateway.getArray("/MedicareAccounts");
                        },
                        getCaseMedicareAccounts: (caseId) => {
                            return crmApiGateway.getArray(`/Cases/${caseId}/MedicareAccounts`);
                        },
                        updateMedicareAccount: (medicareAccountId, medicareAccount) => {
                            return crmApiGateway.put(`/MedicareAccounts/${medicareAccountId}`, medicareAccount);
                        },
                        createMedicareAccount: (medicareAccount) => {
                            return crmApiGateway.post("/MedicareAccounts", medicareAccount);
                        },
                    }

                    return service;
                }
            }
        ]);

})(window.app);